<!--
 * @Date: 2020-09-01 09:42:44
 * @Author: MX
 * @Description:帮助中心
-->
<template>
    <div class="helpCenter">
        <div class="helpCenter-wrap">
            <div class="main-left">
                <div class="main-left-header">
                    <span class="line"></span>
                    帮助中心
                </div>
                <div class="main-left-aside">
                    <!-- <div class="main-left-aside-item">
                      <el-input v-model="searchKey" style="width:192px;" placeholder="请输入"/>
                    </div> -->
                    <div class="subTitle" v-for="(item, index) in asideList" :key="index" :class="{first:index===0,active:tabNum === index}"
                        @click="subTip(index)">
                        <span class="line" v-if="tabNum === index"></span>
                      <div :class="{'font-style': true, activeFont: tabNum === index}">{{item}}</div>
                    </div>
                </div>
            </div>
            <div class="main-right">
                <!-- <div class="main-right-item" v-if="tabNum === 0">
                  <h3>新手指引</h3>
                </div>
                <div class="main-right-item" v-if="tabNum === 1">
                  <h3>平台简介</h3>
                </div> -->
                <div class="main-right-item" v-if="tabNum === 0">
                    <div style="border-bottom: 1px solid #DCDEE1;padding: 0 20px 25px;"><h3><i class="iconfont iconapiwendang_qianmingfangshi"></i>签名工具</h3></div>
                    <div class="content">
                        <h4 class="content-subTitle">签名方式</h4>
                        <p>1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;</p>
                        <p>2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再base64加密;</p>
                        <p>3. 例如：base64(MD5({“age”:18,“gender”:“male”,“name”:“张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。</p>
                        <p>4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。</p>
                        <p>5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；</p>
                        <p>6. 部分接口示例代码和sdk请参考示例代码、SDK文档。</p>
                        <h4 class="content-subTitle bodySign">业务参数签名</h4>
                        <table border cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="first">customerCode</td>
                                <td class="second">
                                    <input type="text" v-model="accountSignForm.customerCode" placeholder="请输入customerCode">
                                </td>
                            </tr>
                            <tr>
                                <td class="first">pwd</td>
                                <td class="second">
                                    <input type="text" v-model="accountSignForm.pwd" placeholder="请输入加密后的32位pwd">
                                </td>
                            </tr>
                            <tr>
                                <td class="first">privatekey</td>
                                <td class="second">
                                    <input type="text" v-model="accountSignForm.privateKey" placeholder="请输入privatekey">
                                </td>
                            </tr>
                            <button class="commonBtn obtain" @click="accountSign">获取</button>
                            <div class="line">
                                <span class="line-key">digest</span>
                                <span class="line-value">{{accountSignDigest}}</span>
                            </div>
                        </table>
                        <section>
                          <p>说明： 在调用下单、取消订单等接口时，可能会需要业务参数<code>digest</code>，业务参数<code>digest</code>和<code>Headers</code>参数里面的<code>digest</code>是不一样的。</p>
                          <p>调用沙箱环境所需的测试参数为：</p>
                          <p>CustormerCode：<code>J0086474299</code></p>
                          <p>pwd：<code>6A272C3DD1F3CD2F92BF567C37040910</code></p>
                          <p>privatekey：<code>0258d71b55fc45e3ad7a7f38bf4b201a</code></p>
                          <p>注：正式环境<code>privatekey</code>请前往 <span class="toControl" @click="jump">控制台-个人中心</span> 查看</p>
                          <p style="padding-top: 10px">
                            <span style="display: block">1. 网点/总部在维护客户资料时，系统会分配一个客户下单所需的账号（<code>CustomerCode</code>）及密码。例如<code>J0086474299/H5CD3zE6</code>。</span>
                            <span style="display: block">2. 业务参数签名中的<code>pwd={明文密码(H5CD3zE6)+jadada236t2}</code> MD5加密为32位后大写。例如<code>6A272C3DF3CD2F92BF567C37040910</code>。</span>
                            <span style="display: block">3. 业务参数<code>digest=Base64{MD5(CustomerCode+pwd+privatekey)}</code>。例如<code>qonqb4O1eNr6VCWS07Ieeg==</code>。</span>
                          </p>
                        </section>
                        <h4 class="content-subTitle bodySign">Headers签名</h4>
                        <table border cellspacing="0" cellpadding="0">
                            <tr>
                                <td class="first">privatekey</td>
                                <td class="second">
                                    <input type="text" v-model="headersSignForm.privateKey" placeholder="请输入privatekey">
                                </td>
                            </tr>
                            <tr>
                                <td class="first signFirst">bizContent</td>
                                <td class="second">
                                    <textarea v-model="headersSignForm.json" placeholder="请输入bizContent"></textarea>
                                </td>
                            </tr>
                            <button class="commonBtn obtain" @click="headersSign">获取</button>
                            <div class="line">
                                <span class="line-key">digest</span>
                                <span class="line-value">{{headersSignDigest}}</span>
                            </div>
                        </table>
                        <section>
                            <p>示例：
                                以取消订单为例：假设业务参数为
                                bizContent为<code>{"customerCode": "J0086474299","digest": " U40e5sumorgd3YgZzU","txlogisticId":
                                    "10000000001299","reason": "YL1234567890123"}</code>,
                                那么此时的header里面的签名digest等于<code>base64(md5(业务参数的Json+privateKey))</code>,</p>
                            <p>即 <code>base64(md5({"customerCode": "J0086474299","digest": " U40e5sumorgd3YgZzU", "txlogisticId":
                                    "10000000001299","reason": "YL1234567890123"}+privateKey))</code>。</p>
                            <p>注：<code>privateKey</code>为账号通过平台认证后自动分配</p>
                        </section>
                    </div>
                </div>
                <div class="main-right-item" v-if="tabNum === 1">
                  <div style="border-bottom: 1px solid #DCDEE1;padding: 0 20px 26px;"><h3>开发文档</h3></div>
                  <Sdk-item style="padding: 10px 30px;"></Sdk-item>
                </div>
                <div class="main-right-item" v-if="tabNum === 2">
                  <div style="border-bottom: 1px solid #DCDEE1;padding: 0 20px 26px;"><h3>新手指引</h3></div>
                  <newPeople style="padding: 10px 30px;"/>
                </div>
                <div class="main-right-item" v-if="tabNum === 3">
                  <Question/>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import {RESPONSE_SUCCESS} from "@/constants"
import SdkItem from "./children/sdkItem"
import Question from "./children/question.vue"
import newPeople from "./children/newPeople.vue"
export default {
  name: "helpCenter",
  components: { SdkItem, Question, newPeople },
  data() {
    return {
        asideList: ["签名工具", "开发文档", "新手指引", "常见问题"], // "新手指引","平台简介",
        tabNum: 0,   
        accountSignForm:{
            customerCode:"",
            pwd:"",
            privateKey:""
        },
        accountSignDigest:"",
        headersSignForm:{
            privateKey:"",
            json:""
        },
        headersSignDigest:"",
        searchKey: ''
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.tabNum = Number(this.$route.query.id)
    }
  },
  watch: {
    'tabNum': {
      deep: true,
      immediate:  true,
      handler(v) {
        let event = 'HelpCenter_Autograph'
        if (v === 0) {
          event = 'HelpCenter_Autograph'
        } else if (v === 1) {
          event = 'HelpCenter_Development_Documentation'
        } else if (v === 2) {
          event = 'HelpCenter_Question'
        }
        window._hmt.push(['_trackCustomEvent', event]);
      }
    }
  },
  methods: {
      /**
       * @description  侧边点击
       */
      subTip(num){
          this.tabNum = num
          document.documentElement.scrollTop = 0
      },
       /**
       * @description  账号秘钥签名
       */
      accountSign(){
          if(!this.accountSignForm.customerCode && !this.accountSignForm.pwd && !this.accountSignForm.privateKey ){
              return this.$message.warning("请完整填写字段")
          }
          this.$API.accountSign(this.accountSignForm).then(res=>{
              if(res.code === RESPONSE_SUCCESS){
                  this.$message.success("获取成功")
                  this.accountSignDigest = res.data
              }else {
                  this.$message.error(res.msg)
              }
          })
      },
       /**
       * @description  json秘钥签名
       */
      headersSign(){
          if(!this.headersSignForm.privateKey && !this.headersSignForm.json ){
              return this.$message.warning("请完整填写字段")
          }
          this.$API.headersSign(this.headersSignForm).then(res=>{
              if(res.code === RESPONSE_SUCCESS){
                  this.$message.success("获取成功")
                  this.headersSignDigest = res.data
              }else {
                  this.$message.error(res.msg)
              }
          })
      },
      //下载模板
      async downloadOneTemplate(type){
          const elink = document.createElement('a')
          elink.style.display = 'none'
          if(type === 1){
            elink.href = this.$API.downloadOneTemplate
          }else if(type === 2){
            elink.href = this.$API.downloadTwoTemplate
          }
          elink.setAttribute('download', name)
         document.body.appendChild(elink)
         elink.click() 
      },
      jump() {
        const url = location.protocol + '//' + location.host + '/#/control/personalCenter'
        window.open(url)
      }
  }
}
</script>

<style lang="scss" scoped>
.toControl {
  color:#E60000;
  cursor: pointer;
}
.toControl:hover {
  text-decoration: underline;
}
    .helpCenter {
      background: #f4f5f7;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      padding-top: 64px;
      min-height: calc(100vh - 64px);
      code {
        font-size: 14px;
        word-wrap: break-word;
        padding: 2px 4px;
        border-radius: 4px;
        margin: 0 2px;
        color: #1e6bb8;
        background-color: rgba(27, 31, 35, 0.05);
        word-break: break-all;
      }
    }
    .helpCenter-wrap {
      padding: 20px 0;
      height: 100%;
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
      display: flex;
      .main-left {
        width: 240px;
        max-height: 300px;
        overflow: auto;
        box-sizing: border-box;
        background: #fff;
        border-radius: 10px;
        position: fixed;
        .main-left-header {
          position: relative;
          height: 71px;
          width: 100%;
          border-bottom: 1px solid $table-border-color;
          color: #2b2d42;
          font-size: 26px;
          font-weight: 900;
          line-height: 26px;
          padding: 22px 0 22px 20px;
          box-sizing: border-box;
          .line {
            width: 4px;
            height: 28px;
            background: $theme-color;
            border-radius: 2px;
            display: inline-block;
            position: absolute;
            left: 0;
            top: 22px;
          }
        }
        .main-left-aside {
          .main-left-aside-item {
            padding: 18px 20px 20px;
            ::v-deep .el-input__inner {
              border-radius: 15px !important;
              height: 36px !important;
              line-height: 36px !important;
            }
          }
          .subTitle {
            position: relative;
            font-size: 16px;
            font-weight: 400;
            color: #61666d;
            line-height: 16px;
            cursor: pointer;
            box-sizing: border-box;
            padding: 7px 3px 7px 10px;
            .font-style {
              height: 36px;
              line-height: 36px;
              border-radius: 6px;
              padding-left: 50px;
            }
            .activeFont {
              background-color: #f2f2f2;
            }
            .line {
              width: 2px;
              height: 36px;
              background: $theme-color;
              border-radius: 2px;
              display: inline-block;
              position: absolute;
              left: 0;
              top: 6px;
            }
            // &.first {
            //   margin-top: 30px;
            // }
            &.active {
              font-weight: 600;
              color: $theme-color;
            }
          }
        }
      }
      .main-right {
        flex: 1;
        background: #fff;
        box-sizing: border-box;
        padding: 22px 0;
        overflow: auto;
        border-radius: 10px;
        width: calc(100% - 260px);
        margin-left: 260px;
        .main-right-item {
          h3 {
            font-size: 22px;
            color: #2b2d42;
            line-height: 22px;
            .iconfont {
              color: $theme-color;
              font-size: 24px;
              margin-right: 16px;
              font-weight: normal;
            }
          }
          .content {
            padding: 10px 30px;
            font-size: 14px;
            font-weight: 400;
            color: #61666d;
            line-height: 22px;
            .content-subTitle {
              height: 22px;
              font-size: 16px;
              font-weight: 600;
              color: #2b2d42;
              line-height: 22px;
              margin-bottom: 10px;
              &.bodySign {
                margin: 50px 0 10px;
              }
            }
            p {
              margin-top: 15px;
              word-break: break-all;
            }
            table {
              position: relative;
              // border-collapse: collapse;
              border: 1px solid $table-border-color;
              border-radius: 4px;
              & > tr {
                border: none;
                &:nth-last-of-type(1) td {
                  border-bottom: none;
                }
              }
              td {
                border: none;
                border-bottom: 1px solid $table-border-color;
                border-right: 1px solid $table-border-color;
                &:nth-last-child(1) {
                  border-right: none;
                }
              }

              td.first {
                width: 120px;
                height: 40px;
                line-height: 40px;
                background: #f9fafc;
                text-align: center;
                color: #4c4d57;
                box-sizing: border-box;
                border-right: 1px solid $table-border-color;
                &.signFirst {
                  height: 100px;
                }
              }
              td.second {
                width: 250px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                position: relative;
                box-sizing: border-box;
                overflow: hidden;
                input {
                  border: none;
                  width: 100%;
                  height: 100%;
                  outline: none;
                  box-sizing: border-box;
                  color: #61666d;
                  padding: 12px;
                  font-size: 14px;
                }
                textarea {
                  border: none;
                  width: 100%;
                  height: 100%;
                  outline: none;
                  box-sizing: border-box;
                  color: #61666d;
                  padding: 12px;
                  font-size: 14px;
                  position: absolute;
                  top: 0;
                  left: 0;
                }
              }
              .obtain {
                width: 100px;
                height: 40px;
                background: $theme-color;
                position: absolute;
                left: 390px;
                top: 40px;
                color: #fff;
              }
              .line {
                position: absolute;
                left: 510px;
                top: 40px;
                border: 1px solid $table-border-color;
                width: 370px;
                height: 40px;
                border-radius: 4px;
                .line-key {
                  width: 120px;
                  height: 40px;
                  line-height: 40px;
                  background: #f9fafc;
                  text-align: center;
                  color: #4c4d57;
                  box-sizing: border-box;
                  border-right: 1px solid $table-border-color;
                  float: left;
                }
                .line-value {
                  width: 250px;
                  height: 40px;
                  line-height: 40px;
                  text-align: center;
                  box-sizing: border-box;
                  float: left;
                }
              }
            }
          }
          .down {
            display: inline-block;
            img {
              display: block;
              width: 100px;
              height: 100px;
              font-size: 0;
            }
            .btn {
              width: 100px;
              height: 32px;
              border: 1px solid #b0b3b6;
              margin-top: 12px;
              &:active,
              &:hover {
                color: $theme-color;
                border-color: $theme-color;
              }
            }
            &:last-of-type {
              margin-left: 40px;
            }
          }
        }
      }
    }
</style>
